import React, { useEffect } from 'react';
import { MapPin, Mail, Clock, Phone, Send } from 'lucide-react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import ScrollToTop from '../components/ScrollToTop';

export default function ContactPage() {
  useEffect(() => { document.title = 'Contact | VoiceraLab'; }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <div className="pt-24 pb-16 max-w-5xl mx-auto px-6">
        <h1 className="text-4xl sm:text-5xl font-bold font-outfit text-center"><span className="text-gradient">Contact Us</span></h1>
        <p className="text-center text-muted-foreground mt-3 max-w-lg mx-auto">Have questions? Our team is ready to help. Reach out to us anytime.</p>
        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div className="glass-card rounded-2xl p-6 border border-border space-y-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center flex-shrink-0"><MapPin className="w-5 h-5 text-blue-500" /></div>
                <div><h3 className="font-semibold text-foreground">USA Address</h3><p className="text-sm text-muted-foreground mt-1">8301 State Line Rd Ste 220<br/>Kansas City, MO 64114</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-green-500/10 flex items-center justify-center flex-shrink-0"><Clock className="w-5 h-5 text-green-500" /></div>
                <div><h3 className="font-semibold text-foreground">Working Hours</h3><p className="text-sm text-muted-foreground mt-1">24/7 Support</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-purple-500/10 flex items-center justify-center flex-shrink-0"><Mail className="w-5 h-5 text-purple-500" /></div>
                <div><h3 className="font-semibold text-foreground">Email</h3><p className="text-sm text-muted-foreground mt-1">hello@voiceralab.com</p></div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl bg-cyan-500/10 flex items-center justify-center flex-shrink-0"><Phone className="w-5 h-5 text-cyan-500" /></div>
                <div><h3 className="font-semibold text-foreground">Phone</h3><p className="text-sm text-muted-foreground mt-1">+44 7853 751372</p></div>
              </div>
            </div>
          </div>
          <div className="glass-card rounded-2xl p-6 border border-border">
            <h3 className="font-semibold font-outfit text-foreground mb-4">Send us a message</h3>
            <form onSubmit={e => { e.preventDefault(); alert('Message sent! We will get back to you soon.'); }} className="space-y-4">
              <div><label className="block text-xs text-muted-foreground mb-1">Name</label><input type="text" required className="w-full px-4 py-2.5 rounded-xl bg-background border border-border text-foreground text-sm focus:border-primary" placeholder="Your name" /></div>
              <div><label className="block text-xs text-muted-foreground mb-1">Email</label><input type="email" required className="w-full px-4 py-2.5 rounded-xl bg-background border border-border text-foreground text-sm focus:border-primary" placeholder="you@example.com" /></div>
              <div><label className="block text-xs text-muted-foreground mb-1">Message</label><textarea rows={4} required className="w-full px-4 py-2.5 rounded-xl bg-background border border-border text-foreground text-sm focus:border-primary resize-none" placeholder="How can we help?" /></div>
              <button type="submit" className="w-full gradient-btn py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2"><Send className="w-4 h-4" /> Send Message</button>
            </form>
          </div>
        </div>
      </div>
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}
